module.exports = __webpack_public_path__ + "media/app_search/FreeTrialExtend/images/clients/client-icon-java-66517ded2b3a6bef72a9c7fc9a1fc931.svg";